module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAG1BMVEUAAAD////////////////////////////////rTT7CAAAACXRSTlMAb/888yjnU/vmZ+oqAAAAvklEQVR4Ae3NsQ3CABBD0aAUtIgNsBA1RSZIFmAJdkjN5PRfUT7XEelcWrLfcPh0OqdLcXC9FYEEhAGJEgCcAKAEACcAKAHACQBKAADhAAgFQDgAQgEQDpBwgIQDJDxJMvyaHvSgBz0Yq4OpOBjnJKkC9yqwVIHnfwLjqwhM7yIwP4wAkBgBIFECwD4BYFiTfQLAcP4IAcAJAE4QcAIACQdIKGDESmCrwx0AdFvEYh3ueMaOWRftcPf0rtM5TL502lIBviJGjAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/merge-white-icon.png
// module id = 332
// module chunks = 0